module.exports = __webpack_public_path__ + "assets/ic-youtube.884ca502.svg";